"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldIcon;
(function (FieldIcon) {
    FieldIcon["BoolCalc"] = "BoolCalc";
    FieldIcon["Bool"] = "Bool";
    FieldIcon["DateCalcContinuous"] = "DateCalcContinuous";
    FieldIcon["DateCalcDiscrete"] = "DateCalcDiscrete";
    FieldIcon["DateContinuous"] = "DateContinuous";
    FieldIcon["DateDiscrete"] = "DateDiscrete";
    FieldIcon["DateTimeCalcContinuous"] = "DateTimeCalcContinuous";
    FieldIcon["DateTimeCalcDiscrete"] = "DateTimeCalcDiscrete";
    FieldIcon["DateTimeContinuous"] = "DateTimeContinuous";
    FieldIcon["DateTimeDiscrete"] = "DateTimeDiscrete";
    FieldIcon["GeoCalcContinuous"] = "GeoCalcContinuous";
    FieldIcon["GeoCalcDiscrete"] = "GeoCalcDiscrete";
    FieldIcon["GeoContinuous"] = "GeoContinuous";
    FieldIcon["GeoDiscrete"] = "GeoDiscrete";
    FieldIcon["Group"] = "Group";
    FieldIcon["GroupGeo"] = "GroupGeo";
    FieldIcon["Hierarchy"] = "Hierarchy";
    FieldIcon["NumberCalcContinuous"] = "NumberCalcContinuous";
    FieldIcon["NumberCalcDiscrete"] = "NumberCalcDiscrete";
    FieldIcon["NumberContinuous"] = "NumberContinuous";
    FieldIcon["NumberDiscrete"] = "NumberDiscrete";
    FieldIcon["NumericBinDiscrete"] = "NumericBinDiscrete";
    FieldIcon["NumericBinContinuous"] = "NumericBinContinuous";
    FieldIcon["Set"] = "Set";
    FieldIcon["TextCalcContinuous"] = "TextCalcContinuous";
    FieldIcon["TextCalcDiscrete"] = "TextCalcDiscrete";
    FieldIcon["TextContinuous"] = "TextContinuous";
    FieldIcon["TextDiscrete"] = "TextDiscrete";
})(FieldIcon = exports.FieldIcon || (exports.FieldIcon = {}));
//# sourceMappingURL=FieldIcon.js.map